import _ from 'lodash'
import React, { useCallback, useState } from 'react'

import { CardIconButton, IconButton } from '../IconButton'

import { IconColor, IconName } from 'Components/Icon'
import { FavoriteIcon } from 'Components/common/FavoriteIcon'
import { ImageUrl } from 'Models'
import { ZIndexPriority } from 'Utils/zIndexPriority'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Callback = (event?: any) => void

export type ResponsiveCardBaseProps = {
  title?: string
  details?: string
  className?: string
  imageUrl?: ImageUrl
  svgUrl?: string | null
  onClick?: Callback
  toggleChildrenIsOn?: boolean
  source?: string
  iconButtons: CardIconButton[]
  cardButtons: JSX.Element[]
  isFavorite?: boolean

  isAccepted?: boolean
  hidden?: boolean
}

export const ResponsiveCardBase: React.FC<ResponsiveCardBaseProps> = ({
  title,
  details,
  className,
  imageUrl = null,
  iconButtons,
  cardButtons,
  isFavorite = false,
  toggleChildrenIsOn,
  source = '',
  onClick,
  hidden,
  children
}) => {
  const handleCardClick = useCallback(() => {
    onClick && onClick()
  }, [onClick])

  const [toggleMenu, setToggleMenu] = useState(false)

  const clazzName = _.compact(['standardcard', className]).join(' ')

  const transparentWhenHidden = { opacity: hidden ? 0.4 : 1 }

  return (
    <div className={clazzName} tabIndex={0}>
      <div style={{ position: 'absolute', top: -7, left: -10, zIndex: ZIndexPriority.LOW }}>
        <FavoriteIcon isFavorite={isFavorite} />
      </div>
      <div
        className={`standardcard-image ${onClick ? 'cursor' : ''}`}
        onClick={handleCardClick}
        style={transparentWhenHidden}
      >
        {imageUrl && <img src={imageUrl.includes('design-system') ? imageUrl : `${imageUrl}&width=120`} alt={title} />}
      </div>
      <div
        className={`standardcard-content ${onClick ? 'cursor' : ''}`}
        onClick={handleCardClick}
        style={transparentWhenHidden}
      >
        <span className="standardcard-title">{title}</span>
        <span className="standardcard-source">{source}</span>
        {details && <span>{details}</span>}
      </div>
      <div tabIndex={0} onBlur={() => setToggleMenu(false)} className="standardcard-icons">
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center' }}>
          {cardButtons.map((icon) => icon)}
        </div>
        <IconButton name={IconName.menuv} color={IconColor.GRAY_2} onClick={() => setToggleMenu(!toggleMenu)} />
        {toggleMenu && (
          <ul className="standardcard-dropdown">
            {iconButtons.map((btn, i) => (
              <li key={i} onClick={() => setToggleMenu(!toggleMenu)}>
                <IconButton name={btn.name} color={btn.color} label={btn.label} onClick={btn.onClick} />
              </li>
            ))}
          </ul>
        )}
      </div>
      {toggleChildrenIsOn ? children : null}
    </div>
  )
}
